<template>
    <div v-if="contest && Object.keys(contest) && Object.keys(contest).length > 0">
    
        <h3 class="u-m0">
            <span class="u-screenreader">{{ contest.title }}</span>
            <!-- U span iznad ubaci isti tekst kao i u naziv taba u navigaciji -->
        </h3>
        <div class="table-wrap">
            <table v-if="contest.competition_published && contest.competition_published === 'Da'" class="table">
                <tbody>
                    <tr class="table-row">
                        <td class="table-cell">
                            Jedinica vlasti
                        </td>
                        <td class="table-cell">
                            {{ contest.township && contest.township.name }}
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="table-cell">
                            Da li je konkurs raspisan?
                        </td>
                        <td class="table-cell">
                            {{ contest.competition_published }}
                        </td>
                    </tr>
                    <tr v-if="contest.calendar !== '01.01.0000.'" class="table-row">
                        <td class="table-cell">
                            Datum raspisivanja konkursa
                        </td>
                        <td class="table-cell">
                            {{ contest.calendar }}
                        </td>
                    </tr>
                    <tr v-if="contest.competition_name" class="table-row">
                        <td class="table-cell">
                            Naziv konkursa
                        </td>
                        <td class="table-cell">
                            {{ contest.competition_name }}
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="table-cell">
                            Da li je konkurs objavljen na sajtu organa vlasti?
                        </td>
                        <td class="table-cell">
                            {{ contest.competition_on_web }}
                        </td>
                    </tr>
                    <tr class="table-row">
                        <td class="table-cell">
                            Da li je konkurs objavljen u štampanom mediju?
                        </td>
                        <td class="table-cell">
                            {{ contest.printed_competition }}
                        </td>
                    </tr>
                    <tr v-if="contest.media_name0" class="table-row">
                        <td class="table-cell">
                            Naziv medija
                        </td>
                        <td class="table-cell">
                            {{ contest.media_name0 }}
                        </td>
                    </tr>
                    <tr v-if="contest.upload_competition != 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                            Prikačeno rešenje o konkursu
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.upload_competition}`" :download="contest.upload_competition">Preuzmi rešenje</a>
                        </td>
                    </tr>
                    <tr v-if="contest.competition_regular" class="table-row">
                        <td class="table-cell">
                            Da li je konkurs ispravan?
                        </td>
                        <td class="table-cell">
                            {{ contest.competition_regular }}
                        </td>
                    </tr>
                    <tr v-if="contest.competition_regular === 'Ne'" class="table-row">
                        <td class="table-cell">
                            Razlozi zbog kojih konkurs nije ispravan?
                        </td>
                        <td class="table-cell">
                            {{ contest.reasons1 }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_remarks" class="table-row">
                        <td class="table-cell">
                            Da li su upućene primedbe na tekst konkursa?
                        </td>
                        <td class="table-cell">
                            {{ contest.mk_remarks }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_remarks === 'Da'" class="table-row">
                        <td class="table-cell">
                            Primedbe koje je upućene na tekst konkursa
                        </td>
                        <td class="table-cell">
                            {{ contest.remarks_area }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_remarks === 'Da' && contest.upload_remarks !== 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                            Izmenjeni tekst konkursa
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.upload_remarks}`" :download="contest.upload_remarks">Preuzmi rešenje</a>
                        </td>
                    </tr>
                    <tr v-if="contest.remarks_accepted" class="table-row">
                        <td class="table-cell">
                            Da li su uvažene primedbe na tekst konkursa?
                        </td>
                        <td class="table-cell">
                            {{ contest.remarks_accepted }}
                        </td>
                    </tr>
                    <tr v-if="contest.remarks_accepted != 'Uvažene'" class="table-row">
                        <td class="table-cell">
                            Zašto primedbe nisu uvažene?
                        </td>
                        <td class="table-cell">
                            {{ contest.remarks_notaccepted }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_users" class="table-row">
                        <td class="table-cell">
                            Da li su predloženi članovi komisije?
                        </td>
                        <td class="table-cell">
                            {{ contest.mk_users }}
                        </td>
                    </tr>
                    <tr v-if="contest.upload_competition1 != 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                            Rešenje o imenovanju članova komisije
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.upload_competition1}`" :download="contest.upload_competition1">Preuzmi rešenje</a>
                        </td>
                    </tr>
                    <tr v-if="suggestedMembers.length > 0" class="table-row">
                        <td class="table-cell">
                            Imena predloženih članove komisije
                        </td>
                        <td class="table-cell">
                            <ol>
                                <li v-for="member in suggestedMembers" :key="member.id">
                                    {{ member.member_name }}
                                    {{ member.organizations.length ? `- ${member.organizations.map(o => o.name).join(', ')}` : '' }}
                                </li>
                            </ol>
                        </td>
                    </tr>
                    <tr v-if="contest.decision_web" class="table-row">
                        <td class="table-cell">
                            Da li je rešenje o imenovanju članova komisije objavljeno na sajtu organa vlasti?
                        </td>
                        <td class="table-cell">
                            {{ contest.decision_web }}
                        </td>
                    </tr>
                    <tr v-if="contest.solution_date" class="table-row">
                        <td class="table-cell">
                            Datum donošenja rešenje za članove
                        </td>
                        <td class="table-cell">
                            {{ contest.solution_date }}.
                        </td>
                    </tr>
                    <tr v-if="chosenMembers.length > 0" class="table-row">
                        <td class="table-cell">
                            Imena izabranih članove komisije
                        </td>
                        <td class="table-cell">
                            <ol>
                                <li v-for="member in chosenMembers" :key="member.id">
                                    {{ member.member_name }}
                                    {{ member.organizations.length ? `- ${member.organizations.reduce((acc, item) => { acc.push(item.name); return acc; }, []).toString()}` : '' }}
                                </li>
                            </ol>
                        </td>
                    </tr>
                    <tr v-if="contest.some_remarks" class="table-row">
                        <td class="table-cell">
                            Da li su upućene primedbe na rešenje o imenovanju komisije?
                        </td>
                        <td class="table-cell">
                            {{ contest.some_remarks }}
                        </td>
                    </tr>
                    <tr v-if="contest.some_remarks === 'Da'" class="table-row">
                        <td class="table-cell">
                            Primedbe koje su upućene na rešenje o imenovanju komisije
                        </td>
                        <td class="table-cell">
                            {{ contest.suggest_remarks }}
                        </td>
                    </tr>
                    <tr v-if="contest.some_remarks === 'Da' && contest.upload_accepted_remarks !== 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                            Izmenjeno rešenje o imenovanju komisije
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.upload_accepted_remarks}`" :download="contest.upload_accepted_remarks">Preuzmi rešenje</a>
                        </td>
                    </tr>
                    <tr v-if="contest.remarks_accepted1" class="table-row">
                        <td class="table-cell">
                            Da li su uvažene primedbe na rešenje o imenovanju komisije?
                        </td>
                        <td class="table-cell">
                            {{ contest.remarks_accepted1 }}
                        </td>
                    </tr>
                    <tr v-if="contest.remarks_accepted1 !== 'Uvažene'" class="table-row">
                        <td class="table-cell">
                            Zašto primedbe nisu uvažene?
                        </td>
                        <td class="table-cell">
                            {{ contest.whynot_accepted }}
                        </td>
                    </tr>
<!-- <tr v-if="contest.traveling_costs" class="table-row">
                    <td class="table-cell">
                        Da li je organ vlasti obezbedio putne troškove?
                    </td>
                    <td class="table-cell">
                        {{ contest.traveling_costs }}
                    </td>
                </tr>
                <tr v-if="contest.honorarium" class="table-row">
                    <td class="table-cell">
                        Da li je organ vlasti obezbedio honorar za člana komisije?
                    </td>
                    <td class="table-cell">
                        {{ contest.honorarium }}
                    </td>
                </tr>
                <tr v-if="contest.honorarium === 'Da'" class="table-row">
                    <td class="table-cell">
                        Iznos honorara za člana komisije
                    </td>
                    <td class="table-cell">
                        {{ contest.honorarium_value }}
                    </td>
                </tr>
            -->
                    <tr v-if="contest.resources_web" class="table-row">
                        <td class="table-cell">
                            Da li je rešenje o raspodeli sredstava objavljeno na sajtu organa vlasti?
                        </td>
                        <td class="table-cell">
                            {{ contest.resources_web }}
                        </td>
                    </tr>
                    <tr v-if="contest.date_money" class="table-row">
                        <td class="table-cell">
                            Datum donošenja rešenja o raspodeli sredstava
                        </td>
                        <td class="table-cell">
                            {{ formatDateFront(contest.date_money) }}.
                        </td>
                    </tr>
                    <tr v-if="contest.upload_decision !== 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                            Rešenje o raspodeli sredstava
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.upload_decision}`" :download="contest.upload_decision">Preuzmi rešenje</a>
                        </td>
                    </tr>
                    <tr v-if="contest.total_money" class="table-row">
                        <td class="table-cell">
                            Ukupna predviđena novčana sredstva na konkursu
                        </td>
                        <td class="table-cell">
                            {{ contest.total_money.toLocaleString('sr') }}
                        </td>
                    </tr>
                    <tr v-if="contest.money_allocated" class="table-row">
                        <td class="table-cell">
                            Koliko je novca raspodeljeno?
                        </td>
                        <td class="table-cell">
                            {{ contest.money_allocated.toLocaleString('sr') }}
                        </td>
                    </tr>
                    <tr v-if="contest.remain_money" class="table-row">
                        <td class="table-cell">
                            Koliko je novca ostalo neraspodeljeno?
                        </td>
                        <td class="table-cell">
                            {{ contest.remain_money.toLocaleString('sr') }}
                        </td>
                    </tr>
                    <tr v-if="contest.project_total" class="table-row">
                        <td class="table-cell">
                            Koliko je ukupno prijavljenih projekata?
                        </td>
                        <td class="table-cell">
                            {{ contest.project_total }}
                        </td>
                    </tr>
                    <tr v-if="contest.granted_projects" class="table-row">
                        <td class="table-cell">
                            Koliko je ukupno odobrenih projekata?
                        </td>
                        <td class="table-cell">
                            {{ contest.granted_projects }}
                        </td>
                    </tr>
                    <tr v-if="contest.projects && contest.projects.length > 0" class="table-row">
                        <td class="table-cell">
                            Dodeljeni iznosi po projektu
                        </td>
                        <td class="table-cell">
                            <div v-for="(project, ind) in contest.projects" :key="ind" class="dodeljeni-iznos-listanje">
                                <div v-if="project.funds">
                                    Iznos: {{ project.funds.toLocaleString('sr') }}
                                </div>
                                <div>
                                    Naziv projekta: {{ project.name }}
                                </div>
                                <div v-if="project.media">
                                    Naziv medija: {{ project.media.media_name }}
                                </div>
                                <div v-if="project.submitter">
                                    Naziv podnosioca: {{ project.submitter.name }}
                                </div>
                                <div v-if="project.contestType">
                                    Tip: {{ project.contestType.type }}
                                </div>
                                <hr v-if="ind < contest.projects.length - 1">
                            </div>
                        </td>
                    </tr>
                    <tr v-if="contest.gouverment_accepted" class="table-row">
                        <td class="table-cell">
                            Da li je organ vlasti prihvatio odluku komisije?
                        </td>
                        <td class="table-cell">
                            {{ contest.gouverment_accepted }}
                        </td>
                    </tr>
                    <tr v-if="contest.gouverment_accepted === 'Ne'" class="table-row">
                        <td class="table-cell">
                            Razlog zbog kog nije prihvaćena odluka komisije
                        </td>
                        <td class="table-cell">
                            {{ contest.rejected_why }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_remarks1" class="table-row">
                        <td class="table-cell">
                            Da li su upućene primedbe na rešenje o raspodeli sredstava?
                        </td>
                        <td class="table-cell">
                            {{ contest.mk_remarks1 }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_remarks1 === 'Da'" class="table-row">
                        <td class="table-cell">
                            Primedbe koje su upućene na rešenje o raspodeli sredstava
                        </td>
                        <td class="table-cell">
                            {{ contest.mk_remarksexp }}
                        </td>
                    </tr>
                    <tr v-if="contest.mk_remarks1 === 'Da'" class="table-row">
                        <td class="table-cell">
                            Da li su uvažene primedbe?
                        </td>
                        <td class="table-cell">
                            {{ contest.remarks_accepted2 }}
                        </td>
                    </tr>
                    <tr v-if="contest.remarks_accepted2 !== 'Uvažene'" class="table-row">
                        <td class="table-cell">
                            Zašto primedbe nisu uvažene?
                        </td>
                        <td class="table-cell">
                            {{ contest.remarks_notaccepted1 }}
                        </td>
                    </tr>
                    <tr v-if="contest.administrative" class="table-row">
                        <td class="table-cell">
                            Da li je pokrenut upravni spor?
                        </td>
                        <td class="table-cell">
                            {{ contest.administrative }}
                        </td>
                    </tr>
                    <tr v-if="contest.administrative === 'Da'" class="table-row">
                        <td class="table-cell">
                            Ko osporava konkurs?
                        </td>
                        <td class="table-cell">
                            {{ contest.who_disputes }}
                        </td>
                    </tr>
                    <tr v-if="contest.report_1 !== 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                            Druga dokumenta u vezi sa konkursom(saopštenja, dopisi, zapisnici...)
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.report_1}`" :download="contest.report_1">Preuzmi dokument</a>
                        </td>
                    </tr>
                    <tr v-if="contest.report_2 !== 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.report_2}`" :download="contest.report_2">Preuzmi dokument</a>
                        </td>
                    </tr>
                    <tr v-if="contest.report_3 !== 'Nema podataka'" class="table-row">
                        <td class="table-cell">
                        </td>
                        <td class="table-cell">
                            <a :href="`https://admin.finansiranjemedija.rs/files/${contest.report_3}`" :download="contest.report_3">Preuzmi dokument</a>
                        </td>
                    </tr>
                    <tr v-if="contest.notices" class="table-row">
                        <td class="table-cell">
                            Napomene i drugi komentari
                        </td>
                        <td class="table-cell">
                            {{ contest.notices }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <table v-else class="table">
                <tbody>
                <tr class="table-row">
                    <td class="table-cell">
                        Jedinica vlasti
                    </td>
                    <td class="table-cell">
                        {{ contest.township && contest.township.name }}
                    </td>
                </tr>
                <tr class="table-row">
                    <td class="table-cell">
                        Da li je konkurs raspisan?
                    </td>
                    <td class="table-cell">
                        {{ contest.competition_published }}
                    </td>
                </tr>
                <tr class="table-row">
                    <td class="table-cell">
                        Napomene i drugi komentari
                    </td>
                    <td class="table-cell">
                        {{ contest.notices }}
                    </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
    <div v-else>
        <p>Nema podataka.</p>
    </div>
</template>

<script>
import { DateTime } from 'luxon';
export default {
    name: 'ContestIndividual',

    props: {
        contest: {
            default: () => ({}),
            type: Object
        }
    },

    computed: {
    suggestedMembers() {
        return (this.contest.commissionMembers || []).filter(member => member.suggested);
    },
    chosenMembers() {
        return (this.contest.commissionMembers || []).filter(member => member.chosen);
    }
    },
    methods: {    
        formatDateFront(dateStr) {
      if (!dateStr) return '';
      return DateTime.fromISO(dateStr)
        .setZone('Europe/Belgrade')
        .toFormat('dd.MM.yyyy');
    } 
}
};
</script>

<style scoped>
/* Add your styles here */
</style>
